// @generated by protobuf-ts 2.11.1 with parameter optimize_code_size,long_type_number
// @generated from protobuf file "bianka/enums/activity/click_type.proto" (package "bianka.enums.activity", syntax proto3)
// tslint:disable
/**
 * @generated from protobuf enum bianka.enums.activity.ClickType
 */
export enum ClickType {
    /**
     * @generated from protobuf enum value: CLICK_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: CLICK_TYPE_LEFT = 1;
     */
    LEFT = 1,
    /**
     * @generated from protobuf enum value: CLICK_TYPE_MIDDLE = 2;
     */
    MIDDLE = 2,
    /**
     * @generated from protobuf enum value: CLICK_TYPE_RIGHT = 3;
     */
    RIGHT = 3
}
